import React, { createContext, useContext, useState } from "react";
import { SHOW_MONTH } from '../../../../../utils/constants/commonConstants';

interface CalendarContextProps {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  mode: string;
  setMode: (mode: string) => void;
}

const CalendarContext = createContext<CalendarContextProps | undefined>(undefined);

export const CalendarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentDate, setCurrentDate] = useState<Date>(new Date()); // ✅ safe default
  const [mode, setMode] = useState(SHOW_MONTH);

  return (
    <CalendarContext.Provider value={{ currentDate, setCurrentDate, mode, setMode }}>
      {children}
    </CalendarContext.Provider>
  );
};

export const useCalendar = () => {
  const ctx = useContext(CalendarContext);
  if (!ctx) throw new Error("useCalendar must be used within a CalendarProvider");
  return ctx;
};